/**
 * WARNING: all listeners set-up by this module MUST BE REMOVED by the returned destroy() function.
 */
Hop.defineModule('ga', (root, cfg) => {
    const $root = $(root);
    if (typeof cfg.event !== 'object' && !Array.isArray(cfg.events) && typeof cfg.category === 'string' && typeof cfg.action !== 'string') {
        throw new Error('Invalid "event", or "events", or "category" and "action" given to module "ga".');
    }

    if (!cfg.event && !cfg.events) {
        cfg.events = [
            {
                category: cfg.category,
                action: cfg.action,
                label: cfg.label,
                value: cfg.value,
            },
        ];
    } else if (!Array.isArray(cfg.events)) {
        cfg.events = [cfg.event];
    }

    function sendEvents() {
        cfg.events.forEach((e) => {
            Hop.safeGA('send', 'event', e.category, e.action, e.label, e.value);
        });
    }

    if (cfg.gaTargets) {
        $root.find(cfg.gaTargets).click(sendEvents);
    } else if ($root.is('form')) {
        $root.submit(sendEvents);
    } else {
        $root.click(sendEvents);
    }

    return function destroy() {
        if (cfg.gaTargets) {
            $root.find(cfg.gaTargets).off('click', sendEvents);
        } else if ($root.is('form')) {
            $root.off('submit', sendEvents);
        } else {
            $root.off('click', sendEvents);
        }
    };
});
